import { c as _c } from "react/compiler-runtime";
// PROBLEM — Figma node 2921:12915 (file N392FVYByl0g8V8bbqHxn9).
// 다크 사진 배경(흐릿한 ChatGPT/코드 화면) 위에 rgba(18,18,18,0.4) 오버레이 + 가운데 흰 텍스트.
// 배경 사진은 Figma PROBLEM 노드를 contentsOnly 렌더 후 한글 오버레이 텍스트만 인페인팅 제거한
// 깨끗한 플레이트(public/inquiry-landing/problem/problem-bg.png). 텍스트는 실제 DOM 텍스트.

const Problem = () => {
  const $ = _c(6);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="pointer-events-none absolute inset-0 bg-[#121212] bg-cover bg-center" style={{
      backgroundImage: "url('/inquiry-landing/problem/PROBLEM-origin.png')"
    }} />;
    t1 = <div aria-hidden={true} className="pointer-events-none absolute inset-0 bg-[rgba(18,18,18,0.4)]" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="block text-[26px] leading-[1.4] tracking-[-0.04em] sm:text-[28px] sm:tracking-[-0.02em] lg:text-[32px] lg:leading-[44.8px]">리뷰는 열심히 관리했는데,</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-[#f9f1f1]">ChatGPT는 우리 병원을</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="max-w-[760px] break-keep font-[family-name:var(--font-nanum-square-neo)] font-extrabold tracking-[-0.02em] text-white">{t2}<span className="block text-[26px] leading-[1.4] tracking-[-0.04em] sm:text-[28px] sm:tracking-[-0.02em] lg:text-[32px] lg:leading-[44.8px]">{t3} <span className="text-white">모릅니다.</span></span></h2>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <section id="problem" className="relative w-full overflow-hidden bg-[#121212] lg:aspect-[1920/265]">{t0}{t1}<div className="relative mx-auto flex max-w-[1140px] flex-col items-center justify-center px-5 py-16 text-center lg:h-full lg:px-7 lg:py-0">{t4}<p className="mt-[18px] max-w-[680px] break-keep text-[16px] font-medium leading-[1.55] text-[#efefef] sm:text-base lg:text-[18px] lg:leading-[24.75px]">환자들은 점점 검색창이 아니라 AI에게 묻습니다. <br aria-hidden={true} className="sm:hidden" />노출되지 않는 리뷰는, 없는 것과 같습니다.</p></div></section>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default Problem;